import { THEMES, THEME_IDS, DEFAULT_THEME_ID } from './themeTokens.mjs';

export type ThemeId = (typeof THEME_IDS)[number];

const raw = import.meta.env.VITE_THEME as string | undefined;
const isKnownThemeId = (value: string): value is ThemeId =>
  (THEME_IDS as readonly string[]).includes(value);

export const ACTIVE_THEME_ID: ThemeId = raw && isKnownThemeId(raw) ? raw : (DEFAULT_THEME_ID as ThemeId);

if (import.meta.env.DEV && raw && !isKnownThemeId(raw)) {
  console.warn(`[theme] Unknown VITE_THEME="${raw}", falling back to "${DEFAULT_THEME_ID}".`);
}

export const ACTIVE_THEME = THEMES[ACTIVE_THEME_ID];
